module.exports = __webpack_public_path__ + "img/bathroom_thumb.9d27cd69.jpg";